export const SERVER = 'https://appedu.codesii.com/';
export const API = 'https://appedu.codesii.com/api/app/v1/';
export const RESOURCES = 'https://www.edu.codesii.com/public/uploaded/';
export const SERVER_EDU_CODESII = 'https://www.edu.codesii.com/';
